import React from "react";
import { IMenuItem } from "../../@types/types";
import { handleLinkClick } from "../../utils";

interface NavItemsProps {
  items: IMenuItem[];
}

const NavItems: React.FC<NavItemsProps> = ({ items }) => {
  const firstItem = items.filter((e) => e.isVisible)[0];

  return (
    <ul className='inner-group'>
      {items.map((item) => {
        if (item.isVisible) {
          return (
            <li
              key={item.id}
              className={
                firstItem && item.id === firstItem.id
                  ? "nav-item inner-nav top"
                  : "nav-item inner-nav "
              }
              onClick={() =>
                handleLinkClick(item.targetUrl, item.targetType === "BLANK")
              }
            >
              {item.targetType === "BLANK" ? (
                <a
                  href={item.targetUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='nav-text-link'
                >
                  {item.title}
                </a>
              ) : (
                <a href={item.targetUrl} className='nav-text-link'>
                  {item.title}
                </a>
              )}
            </li>
          );
        }

        return null;
      })}
    </ul>
  );
};

export default NavItems;
